<template>
  <div class="container_box">
    <!--功能按钮操作区域-->
    <div class="operation_box" v-if="getPermission('ymsMerchantGroup_insertYmsMerchantGroup')">
      <Button type="primary" class="mr15" @click="$refs['createGroup'].initGroupData('add')">{{ $t('key1003172') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="tableDom"
        :draggable="draggable"
        highlight-row
        border
        max-height="650"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        @on-drag-drop="dragDrop">
      </Table>
    </div>
    <!--创建、编辑分组-->
    <createGroupModal ref="createGroup" @updateData="getList()"></createGroupModal>
    <!--删除分组弹窗(分组有客户)-->
    <deleteGroupModal ref="deleteGroup" :groupList="tableData" @updateData="getList()"></deleteGroupModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import createGroupModal from "@/views/yms/components/customerManage/createGroupModal.vue";
import deleteGroupModal from "@/views/yms/components/customerManage/deleteGroupModal.vue";
import {getAllUsersInfo, getUserNameByUserId} from "@/utils/common";

export default {
  name: "customerGroups",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      tableColumns: [
        {
          title: '',
          key: 'sort',
          align: 'center',
          width: 60,
          renderHeader: (h, params) => {
            return h('span', '');
          },
          render: (h, params) => {
            return v.tableData.length > 0 ? h('div', {
              class: 'cursor-move',
              on: {
                mousedown() {
                  v.draggable = true;
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-move',
                  size: 18
                },
                class: 'cursor-move'
              })
            ]) : '';
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003005'),
          key: 'sortNo',
          width: 80,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003166'),
          key: 'groupName',
          minWidth: 140,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003167'),
          key: 'quantity',
          minWidth: 140,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          align: 'left',
          minWidth: 170,
          key: 'createdTime',
          render(h, params) {
            let createdTime = params.row.createdTime;
            return h('span', v.$uDate.dealTime(createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002158'),
          key: 'createdBy',
          minWidth: 130,
          align: 'left',
          render(h, params) {
            return h('div', getUserNameByUserId(params.row.createdBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003168'),
          key: 'remark',
          width: 350,
          align: 'left',
          render(h, params) {
            let remark = params.row.remark;
            return v.checkContentOverflow(h, remark, 350, 2);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          width: 220,
          align: 'left',
          render: (h, params) => {
            let ymsMerchantGroupId = params.row.ymsMerchantGroupId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsMerchantGroup_saveYmsMerchantGroup'),
                    clickFn: () => {
                      let data = JSON.parse(JSON.stringify(params.row));
                      v.$refs['createGroup'].initGroupData('edit', data);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    color: '#FF0000',
                    show: v.getPermission('ymsMerchantGroup_deleteByYmsMerchantGroup'),
                    clickFn: () => {
                      v.deleteGroupBtn(ymsMerchantGroupId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      draggable: false,
      userInfoList: {}
    };
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      (async () => {
        await getAllUsersInfo().then((data) => {
          v.userInfoList = data;
        });
        await v.getList();
      })();
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.tableData = [];
      v.optionBtnWidth = [];
      if (v.getPermission('ymsMerchantGroup_queryTabGroupName')) {
        v.tableLoading = true;
        v.axios.get(api.get_ymsMerchantGroup_queryTabGroupName).then(response => {
          if (response.data.code === 0) {
            v.tableData = response.data.datas || [];
            v.updateTableDom('tableDom');
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 查询当前客户分组下是否有客户
    getMerchantGroupData(ymsMerchantGroupId) {
      let v = this;
      return new Promise((resolve) => {
        v.axios.get(api.get_ymsDistributorMerchant_ymsMerchantGroup + ymsMerchantGroupId).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            resolve(data);
          }
        });
      });
    },
    // 删除分组
    deleteGroupBtn(ymsMerchantGroupId) {
      let v = this;
      v.getMerchantGroupData(ymsMerchantGroupId).then((data) => {
        if (data.length > 0) {
          v.$refs['deleteGroup'].initDeleteGroupData(ymsMerchantGroupId);
        } else {
          v.$Modal.confirm({
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003169'),
            content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003170'),
            okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003171'),
            cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
            onOk: () => {
              let query = {deleteYmsMerchantGroupId: ymsMerchantGroupId};
              v.axios.post(api.post_ymsMerchantGroup_deleteByYmsMerchantGroup, query,
                {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
                if (response.data.code === 0) {
                  v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002957'));
                  v.getList();
                }
              });
            },
            onCancel: () => {
            }
          });
          // 动态修改确定按钮的状态
          v.$nextTick(() => {
            const modalEl = document.querySelector('.ivu-modal-confirm');
            const okBtn = modalEl.querySelector('.ivu-btn-primary');
            okBtn.classList.remove('ivu-btn-primary');
            okBtn.classList.add('ivu-btn-error');
          });
        }
      });
    },
    // 拖拽排序
    dragDrop(oldIndex, newIndex) {
      let v = this;
      const tempSortNo = this.tableData[oldIndex].sortNo;
      this.tableData[oldIndex].sortNo = this.tableData[newIndex].sortNo;
      this.tableData[newIndex].sortNo = tempSortNo;
      v.draggable = false;
      v.$forceUpdate();
      setTimeout(() => {
        v.updateSortData();
      }, 200);
    },
    // 更新排序数据
    updateSortData() {
      let v = this;
      let list = [];
      v.tableData.map((item) => {
        list.push({
          groupName: item.groupName,
          remark: item.remark,
          sortNo: item.sortNo,
          ymsMerchantGroupId: item.ymsMerchantGroupId
        });
      });
      v.axios.put(api.put_ymsMerchantGroup_saveYmsMerchantGroup + '?type=2', list,
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.getList();
        }
      });
    }
  },
  components: {
    createGroupModal,
    deleteGroupModal
  }
};
</script>

<style lang="less" scoped>

</style>